import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireActive = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireActive && !user.subscription_active) return <Navigate to="/subscribe" replace />;
  return children;
}
